import { TableCell, TableRow, TextField, Tooltip } from "@mui/material"
import { FlowContaBaixaDTO, TContasBaixar } from "pages/financas/financas.model"
import { memo } from "react"
import { NumericFormat } from "react-number-format"
import { theme } from "theme";
import { currencyOf } from "utils/util"

export enum SourceType {
    event = "event",
    props = "prop"
}

export type TItemBaixarContaReceber = {
    item: FlowContaBaixaDTO;
    isDisabled: (item: FlowContaBaixaDTO) => boolean
    getValorTotalRecebido: (item: FlowContaBaixaDTO) => number;
    onValueChange: (floatValue: number | undefined, source: SourceType, item: FlowContaBaixaDTO, state: TContasBaixar) => void
}

const ItemBaixarContaReceber = (props: TItemBaixarContaReceber) => {
    return (
        <TableRow sx={{
            display: "flex",
            alignItems: "center",
            color: theme.palette.common.black,
            height: "40px"
        }}>
            <Tooltip title={props.item.descricao}>
                <TableCell sx={{
                    padding: 0,
                    paddingLeft: "15px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    width: "calc(32.5% - 5px)",
                    minWidth: "calc(32.5% - 5px)",
                    maxWidth: "calc(32.5% - 5px)",
                    marginTop: "5px",
                    marginRight: "5px",
                    paddingBottom: "5px",
                    fontSize: "1rem"
                }}>
                    {props.item.descricao}
                </TableCell>
            </Tooltip>

            <TableCell sx={{
                padding: 0,
                textAlign: "center",
                width: "calc(5% - 5px)",
                minWidth: "calc(5% - 5px)",
                maxWidth: "calc(5% - 5px)",
                marginTop: "5px",
                marginRight: "5px",
                paddingBottom: "5px",
                fontSize: "1rem"
            }}>
                {props.item.parcela}
            </TableCell>

            <TableCell sx={{
                padding: 0,
                textAlign: "center",
                width: "calc(9% - 5px)",
                minWidth: "calc(9% - 5px)",
                maxWidth: "calc(9% - 5px)",
                marginTop: "5px",
                marginRight: "5px",
                paddingBottom: "5px",
                fontSize: "1rem"
            }}>
                {props.item.vencimento}
            </TableCell>

            <TableCell sx={{
                padding: 0,
                textAlign: "center",
                width: "calc(10% - 5px)",
                minWidth: "calc(10% - 5px)",
                maxWidth: "calc(10% - 5px)",
                marginTop: "5px",
                marginRight: "5px",
                paddingBottom: "5px",
                fontSize: "1rem",
            }}>
                {currencyOf(props.item.valorAberto)}
            </TableCell>

            <NumericFormat sx={{
                width: "calc(10% - 5px)",
                minWidth: "calc(10% - 5px)",
                maxWidth: "calc(10% - 5px)",
                marginRight: "5px",
            }}
                decimalScale={2}
                fixedDecimalScale
                allowedDecimalSeparators={[',']}
                customInput={TextField}
                decimalSeparator=","
                prefix={'R$ '}
                thousandsGroupStyle="thousand"
                thousandSeparator="."
                inputProps={{
                    style: {
                        fontSize: "1rem",
                        textAlign: "center"
                    }
                }}
                variant="standard"
                allowNegative={false}
                value={props.item.valorRecebido}
                onValueChange={({ floatValue }, { source }) => props.onValueChange(floatValue ?? 0, source, props.item, "valorRecebido")}
                isAllowed={({ floatValue }) => { return (floatValue ?? 0) <= props.item.valorAberto }}
            />

            <NumericFormat sx={{
                width: "calc(7.5% - 5px)",
                minWidth: "calc(7.5% - 5px)",
                maxWidth: "calc(7.5% - 5px)",
                marginRight: "5px"
            }}
                decimalScale={2}
                fixedDecimalScale
                defaultValue={0}
                inputProps={{
                    style: {
                        fontSize: "1rem",
                        textAlign: "center"
                    }
                }}
                allowedDecimalSeparators={[',']}
                customInput={TextField}
                decimalSeparator=","
                prefix={'R$ '}
                thousandsGroupStyle="thousand"
                thousandSeparator="."
                variant="standard"
                allowNegative={false}
                value={props.item.multa}
                onValueChange={({ floatValue }, { source }) => props.onValueChange(floatValue ?? 0, source, props.item, "multa")}
            />

            <NumericFormat sx={{
                width: "calc(7.5% - 5px)",
                minWidth: "calc(7.5% - 5px)",
                maxWidth: "calc(7.5% - 5px)",
                marginRight: "5px"
            }}
                decimalScale={2}
                fixedDecimalScale
                defaultValue={0}
                inputProps={{
                    style: {
                        fontSize: "1rem",
                        textAlign: "center"
                    }
                }}

                allowedDecimalSeparators={[',']}
                customInput={TextField}
                decimalSeparator=","
                prefix={'R$ '}
                thousandsGroupStyle="thousand"
                thousandSeparator="."
                variant="standard"
                allowNegative={false}
                value={props.item.juros}
                onValueChange={({ floatValue }, { source }) => props.onValueChange(floatValue ?? 0, source, props.item, "juros")}
            />

            <NumericFormat sx={{
                width: "calc(7.5% - 5px)",
                minWidth: "calc(7.5% - 5px)",
                maxWidth: "calc(7.5% - 5px)",
                marginRight: "5px"
            }}
                inputProps={{
                    style: {
                        fontSize: "1rem",
                        textAlign: "center"
                    }
                }}
                decimalScale={2}
                fixedDecimalScale
                defaultValue={0}
                allowedDecimalSeparators={[',']}
                customInput={TextField}
                decimalSeparator=","
                prefix={'R$ '}
                thousandsGroupStyle="thousand"
                thousandSeparator="."
                variant="standard"
                allowNegative={false}
                value={props.item.desconto}
                isAllowed={({ floatValue }) => {
                    if (floatValue !== undefined && floatValue > (props.item.valorAberto + props.item.multa + props.item.juros)) return false
                    return true
                }}
                onValueChange={({ floatValue }, { source }) => props.onValueChange(floatValue ?? 0, source, props.item, "desconto")}
            />

            <TableCell sx={{
                padding: 0,
                textAlign: "center",
                width: "calc(10% - 5px)",
                minWidth: "calc(10% - 5px)",
                maxWidth: "calc(10% - 5px)",
                marginTop: "5px",
                paddingBottom: "5px",
                fontSize: "1rem",
            }}>
                {currencyOf(props.getValorTotalRecebido(props.item))}
            </TableCell>
        </TableRow>
    )
}

export default memo(ItemBaixarContaReceber)
